import ObjetMetier from '@/generated/classes/ObjetMetier';
export default class ObjetMetierExtend  extends ObjetMetier {
  constructor() {
    super();
  }
}
